import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'

import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

Vue.use(Vue2TouchEvents,
  {
    tapTolerance: 20
  })

Vue.config.productionTip = false

/* global WF_MAP_TYPE */

//import VueDragscroll from 'vue-dragscroll'
//Vue.directive(VueDragscroll)

//import vuescroll from 'vue-scroll' 
//Vue.use(vuescroll)

function loadScript(url, callback) {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(s);
  if (typeof callback == "function") {
    s.onload = callback;
    s.src = url;
  }
}

function loadVue () {
  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app')
}

function load3D () {
  loadScript("//static.3dwayfinder.com/shared/js/minified/frak-stable.min.js", function () {
    loadScript("//static.3dwayfinder.com/js/dist/3d/latest/Wayfinder3D.min.js", function () {
      loadVue();
    });
  });
}

if(location && location.search) {
  var options = unescape(location.search.substring(1));
  if (options.indexOf("mobile=") > -1) {
    WF_MAP_TYPE = "2d";
    loadScript("//static.3dwayfinder.com/js/dist/2d/latest/Wayfinder2D.min.js", function () {
      loadVue();
    });
  }
  else {
    load3D();
  }
}
else {
  load3D();
}


